module.exports = __webpack_public_path__ + "images/emoji/octopus.86663db39ad9fc1e5d55.png";